<template>
  <div v-if="show_button" class="col-md-12 space">
    <a
      :class="supportButtonClass"
      @click="supportComment"
      @keyup.enter="supportComment"
      v-tooltip.bottom="tooltipText"
      tabindex="0"
      role="link"
    >
      <font-awesome-icon :icon="['far', 'thumbs-up']" aria-hidden="true" />
      <span class="visually-hidden">{{ tooltipText }}</span>
    </a>
    <OverlayPanel ref="loginOP" :showCloseIcon="true" :dismissable="true" appendTo="body" class="wdw-widgets">
      <p v-if="!isLoggedIn">{{ domainStore.translate('discuss.comment.support.requires-login') }}</p>
      <Login :domainid="domainid" />
    </OverlayPanel>
    <span v-if="support_count > 0">{{ support_text }}</span>
    <br />
    <span v-if="support_error !== ''" class="text-danger comment-support-summary">
      {{ support_error }}
    </span>
  </div>
</template>

<script>
import { computed, ref, toRef, toRefs, watch } from 'vue';
import { userStore } from '@/store/user-store';
import { projectStore } from '@/store/project-store';
import { domainStore } from '@/store/domain-store';
import commentRepository from '@/api/commentRepository';
import OverlayPanel from 'primevue/overlaypanel';
import Login from '@/components/user/Login.vue';

export default {
  name: 'CommentSupport',
  props: {
    comment: {
      required: true,
      type: Object,
    },
    topicid: {
      required: true,
      type: Number,
    },
  },

  components: {
    OverlayPanel,
    Login,
  },

  setup(props, context) {
    const { comment } = toRefs(props);
    //-------------------------VARIABLES----------------------------
    const support_count = ref(comment.value.supportcount);
    const show_support = ref(comment.value.show_support);
    const has_support = ref(comment.value.has_supported);
    const support_error = ref('');
    const topic = ref(null);
    const loginOP = ref();
    topic.value = projectStore.getFetchedTopic(props.topicid);

    // ---------------------COMPUTED------------------------------
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const show_button = computed(() => {
      return show_support.value == 1 && topic.value.comments_new_support == 1;
    });

    const supportButtonClass = computed(() => {
      return {
        'widget-comment-support-button-container': true,
        voted: has_support.value,
        up: true,
        btn: true,
      };
    });

    const support_text = computed(() => {
      return domainStore.translate('discuss.comment.support.current-support-text', { count: support_count.value });
    });
    const tooltipText = computed(() => {
      return has_support.value
        ? domainStore.translate('discuss.comment.support.button-already-supported')
        : domainStore.translate('discuss.comment.support.button-can-support');
    });
    // ----------------------------------METHODE--------------------------------

    const supportComment = event => {
      if (comment.value.show_support == 1 && topic.value.comments_new_support == 1) {
        if (topic.value.comments_anon_support == 0 && !isLoggedIn.value) {
          loginOP.value.show(event);
        } else {
          commentRepository
            .supportComment(comment.value.commentid)
            .then(response => {
              support_count.value = response.data.supportcount;
              has_support.value = response.data.user_support;
            })
            .catch(error => {
              support_error.value = domainStore.translate('discuss.comment.support.no-support-possible');
            });
        }
      }
    };
    //--------------------------------WATCH--------------------------------
    watch(comment, (newComment, oldComment) => {
      has_support.value = newComment.has_supported;
    });

    return {
      //------------Variable-------------
      domainStore,
      support_error,
      support_count,
      loginOP,
      //------------Computed-------------
      domainid,
      support_text,
      show_button,
      supportButtonClass,
      tooltipText,
      isLoggedIn,
      //------------Methode--------------
      supportComment,
    };
  },
};
</script>
<style lang="scss" scoped>
.col-md-12.space {
  margin-top: 1.1em;
  font-size: 0.826em;
}
.btn.widget-comment-support-button-container {
  background-color: #6b7881;
  color: #fff;
  text-align: center;
  overflow: hidden;
  font-size: 1.2em;
  margin-right: 0.375em;
  margin-top: 0.188em;
  margin-bottom: 0.188em;
  padding: 0.375em 0.628em 0.628em 0.628em;
  border-radius: 0.125em 0.125em 0.125em 0.125em;
  &:hover,
  &:active,
  &:focus {
    background-color: #fff;
    color: #6b7881;
    border-radius: 0.125em 0.125em 0.125em 0.125em;
  }
  &.voted {
    border-top: 5px;
    background-color: #23cc71;
    color: #fff;
    &:hover {
      background-color: #23cc71;
      color: #fff;
    }
  }
}
.wdw-widgets.text-danger::after {
  content: '\a';
  white-space: pre;
}
.text-danger.comment-support-summary {
  float: right;
  margin-top: 0.588em;
  margin-right: 14em;
}
</style>
